import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react'

// Cmd+K or Cmd+P (Mac) / Ctrl+K or Ctrl+P (Windows/Linux)
export const isSpotlightEvent = (e: KeyboardEvent) =>
  (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'p')

interface SpotlightContextValue {
  isOpen: boolean
  open: () => void
  close: () => void
}

const SpotlightContext = createContext<SpotlightContextValue | null>(null)

export const SpotlightProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isSpotlightEvent(e)) {
        e.preventDefault()
        setIsOpen(true)
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <SpotlightContext.Provider
      value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}
    >
      {children}
    </SpotlightContext.Provider>
  )
}

export const useSpotlightShortcut = () => {
  const context = useContext(SpotlightContext)
  if (!context) {
    throw new Error('useSpotlightShortcut must be used within a SpotlightProvider')
  }
  return context
}
